module.exports = __webpack_public_path__ + "static/media/registro-login.d7b373dd.jpg";